import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import GrayPanel from '../../components/GrayPanel';
import { capitalizeFirstLetter } from '../../lib/utils';

class DecisionData extends React.Component {


  render() {
    // layout classes
    const leftCol = 'col-sm-2';
    const labelCol = 'col-sm-2';
    const inputCol = 'col-sm-6';
    const rightCol = 'col-sm-2';

    // really simple styles
    const labelStyle = { marginTop: '.5rem' };
    const rowStyle = { marginTop: '15px' };

    const formDict = {
      Description: {
        label: 'Opis planowanej inwestycji',
      },
      ParcelNo: {
        label: 'Numer działki',
      },
      AddressCity: {
        label: 'Miejscowość',
      },
      AddressStreet: {
        label: 'Ulica',
      },
      AddressFlat: {
        label: 'Numer lokalu',
      },
      AddressNumber: {
        label: 'Numer budynku',
      },
      AddressZipCode: {
        label: 'Kod pocztowy',
      },
    };

    return (
      <GrayPanel title={ this.props.title }>
        {Object.keys(formDict).map((v, i) => {
          return (
            <div className="row mobile-row" key={i} style={rowStyle}>
              <div className={leftCol} />
              <div className={labelCol}>
                <label style={labelStyle}>{formDict[v].label}</label>
              </div>
              <div className={inputCol}>
               {Object.keys(this.props).indexOf('onChange' + capitalizeFirstLetter(v)) > -1 ? 
                <input
                  className="form-control"
                  value={this.props.data[v] ? this.props.data[v] : ''}
                  onChange={e => this.props['onChange' + capitalizeFirstLetter(v)](e) }
                /> : 
                <input
                  className="form-control"
                  value={this.props.data[v] ? this.props.data[v] : ''}
                  disabled
                />
              }
              </div>
              <div className={rightCol} />
            </div>
          );
        })}
      </GrayPanel>
    )
  }
}


export default DecisionData;


// WEBPACK FOOTER //
// src/containers/DecisionData/index.jsx